import { onInstallService, useOnReinstall } from './handlers/install'

const CLIENT_ID = '182926064962.4265833430647'

export const SLACK = {
  CLIENT_ID,
  REDIRECT_URI: `${process.env.REACT_APP_BASE_DOMAIN}/middleware/integrations/slack`,
  onInstall: onInstallService,
  onReinstall: useOnReinstall,
  SCOPE: [
    'chat:write',
    'commands',
    'chat:write.public',
    'channels:read',
    'groups:read',
    'team:read',
    'users.profile:read',
    'users:read',
    'users:read.email'
  ]
}

export default SLACK
